module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am707-98350912c38ef89202f308e7f2ba2b6d.jpg";